import { Button, Link, Stack, Typography } from '@mui/material';
import dynamic from 'next/dynamic';
import React from 'react';

function Custom404() {
  return (
    <Stack
      spacing={2}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Typography variant='h1'>404 - Page Not Found</Typography>
      <Typography variant='h3'>Looks like this page doesn't exist</Typography>

      <Link href={`/hub`}>
        <Button variant='contained'>Back to home</Button>
      </Link>
    </Stack>
  );
}

export default dynamic(() => Promise.resolve(Custom404), {
  ssr: false,
});
